import EmailPair from "@/assets/img/compatibility/email-pair.png"
import { cn } from "@/lib/utils"
import { SIGN_GLYPH, signFromDate } from "../../lib/zodiac"

interface ZodiacPairProps {
  /** ISO birth dates; each resolves to a zodiac sign overlaid on a sphere. */
  userDate?: string
  partnerDate?: string
  className?: string
}

/**
 * Dumb "You + Partner" zodiac header (Figma "All Zodiac Compatibility Pairs").
 * Uses the pre-composed sphere-pair image (empty spheres + "+" + threads + ring +
 * glow, at the exact 414×340 design size) and overlays the two signs on the
 * spheres at the documented 78×78 slots (x=63 / x=273, y=110). Signs come from
 * the collected birth dates.
 */
export function ZodiacPair({ userDate, partnerDate, className }: ZodiacPairProps) {
  const you = signFromDate(userDate)
  const partner = signFromDate(partnerDate)

  return (
    <div
      data-slot="zodiac-pair"
      className={cn("relative mx-auto aspect-[414/340] w-full max-w-app", className)}
    >
      <img
        src={EmailPair}
        alt=""
        className="pointer-events-none absolute inset-0 size-full object-contain"
      />
      <img
        src={SIGN_GLYPH[you]}
        alt=""
        className="absolute top-[32.4%] left-[15.2%] aspect-square w-[18.8%]"
      />
      <img
        src={SIGN_GLYPH[partner]}
        alt=""
        className="absolute top-[32.4%] left-[65.9%] aspect-square w-[18.8%]"
      />
    </div>
  )
}
